<template>
  <div class="paypal-advanced">
    <div id="paypal-button-container" class="paypal-button-container"></div>
    <div id="container" class="gpay-button-custom"></div>
    <div id="card-form" class="card_container">
      <div id="card-name-field-container"></div>
      <div id="card-number-field-container"></div>
      <div id="card-expiry-field-container"></div>
      <div id="card-cvv-field-container"></div>
      <label>{{ t('giftCard.label.billingInformation', { namespace: 'giftCards' }) }}</label>
      <div>
        <input
          type="text"
          id="card-billing-address-line-1"
          name="card-billing-address-line-1"
          v-model="data.address1"
          placeholder="Address line 1"
        />
      </div>
      <div>
        <input
          type="text"
          id="card-billing-address-line-2"
          name="card-billing-address-line-2"
          v-model="data.address2"
          placeholder="Address line 2"
        />
      </div>
      <div>
        <input
          type="text"
          id="card-billing-address-country-code"
          name="card-billing-address-country-code"
          v-model="data.country"
          placeholder="Country code"
        />
      </div>
      <div>
        <input
          type="text"
          id="card-billing-address-postal-code"
          name="card-billing-address-postal-code"
          v-model="data.postal"
          placeholder="Postal/zip code"
        />
      </div>
      <button
        id="card-field-submit-button"
        class="submit-button"
        type="button"
      >
        Pay now with Card
      </button>
    </div>
    <p id="result-message">{{ resultMessage }}</p>
  </div>
</template>

<script>

export default {
  name: 'PaypalAdvanced',
  props: {
    data: Object,
    resultMessage: String,
  },
  created () {
    this.loadScript()
  },
  mounted() {
    let style = document.createElement('link');
    style.type = "text/css";
    style.rel = "stylesheet";
    style.href = 'https://www.paypalobjects.com/webstatic/en_US/developer/docs/css/cardfields.css';
    document.head.appendChild(style);
    window.paypalData = this.data;
  },
  methods: {
    loadScript () {
      const script = document.createElement('script')
      script.src = `https://www.paypal.com/sdk/js?client-id=${this.data.clientId}&buyer-country=${this.data.country}&currency=${this.data.currency}&components=buttons,card-fields,googlepay`;
      script.dataset.sdkIntegrationSource = "developer-studio";
      document.body.appendChild(script);
      script.onload = () => {
        const buttonsScript = document.createElement('script')
        buttonsScript.src = `/ui/main/js/paypal.js`
        document.body.appendChild(buttonsScript)
      };
    },
},
};
</script>

<style>
.gpay-button-custom {
  max-width: 750px;
  padding: 0 20px;
  margin: 0 auto;
}

#gpay-button-online-api-id {
  width: 100%;
  height: 55px;
}

.gpay-card-info-iframe {
  height: 75% !important;
}
</style>
